export default function getTrigger( eventTarget, selector ) {
	if ( eventTarget.matches( selector ) ) {
		return eventTarget;
	}

	return eventTarget.closest( selector );
}
